import React from 'react';
import { TaskSection } from 'components/common/TaskSection';
import FileList from 'components/common/media/FileList/FileList';
import AddDocumentsModal from './AddDocumentsModal';

const Documents = ({
  index,
  orderId,
  documents,
  onDeleteFile,
  disabled,
  onGetDocuments,
}) => {
  const actionsRender = () => {
    return (
      <AddDocumentsModal
        index={index}
        orderId={orderId}
        onGetDocuments={onGetDocuments}
        disabled={disabled}
      />
    );
  };

  return (
    <TaskSection title="Documents" action={actionsRender()} isEmbedded>
      {documents.length === 0 && <div>No documents added.</div>}
      {documents.length > 0 && (
        <FileList
          files={documents}
          onDeleteFile={onDeleteFile}
          enablePreviewFile
        />
      )}
    </TaskSection>
  );
};

export default Documents;
